export interface NavLink {
  label: string
  href: string
}

export interface NavGroup {
  label: string
  href: string
  links: NavLink[]
}

export const navGroups: NavGroup[] = [
  {
    label: 'Products',
    href: '/products/',
    links: [
      { label: 'Overview', href: '/products/' },
      { label: 'Starter Kits', href: '/products/starter-kits/' },
      { label: 'Tool Holders', href: '/products/holders/' },
      { label: 'Inserts & Chipbreakers', href: '/products/inserts/' },
      { label: 'Accessories', href: '/products/accessories/' },
    ],
  },
  {
    label: 'Applications',
    href: '/applications/',
    links: [
      { label: 'Overview', href: '/applications/' },
      { label: 'Aluminum', href: '/applications/aluminum/' },
      {
        label: 'Copper & Soft Alloys',
        href: '/applications/copper-soft-alloys/',
      },
      { label: 'Titanium', href: '/applications/titanium/' },
    ],
  },
  {
    label: 'Technical Resources',
    href: '/technical-resources/',
    links: [
      { label: 'Overview', href: '/technical-resources/' },
      { label: 'Starting Data', href: '/technical-resources/starting-data/' },
      { label: 'Tool Selection', href: '/technical-resources/tool-selection/' },
      { label: 'Safety', href: '/technical-resources/safety/' },
    ],
  },
]

export const topLevelLinks: NavLink[] = [
  { label: 'About', href: '/about/' },
  { label: 'Contact', href: '/contact/' },
]

export const footerGroups: { label: string; links: NavLink[] }[] = [
  {
    label: 'Products',
    links: [
      { label: 'Starter Kits', href: '/products/starter-kits/' },
      { label: 'Tool Holders', href: '/products/holders/' },
      { label: 'Inserts & Chipbreakers', href: '/products/inserts/' },
      { label: 'Accessories', href: '/products/accessories/' },
    ],
  },
  {
    label: 'Applications',
    links: [
      { label: 'Aluminum', href: '/applications/aluminum/' },
      {
        label: 'Copper & Soft Alloys',
        href: '/applications/copper-soft-alloys/',
      },
      { label: 'Titanium', href: '/applications/titanium/' },
    ],
  },
  {
    label: 'Resources',
    links: [
      { label: 'Starting Data', href: '/technical-resources/starting-data/' },
      { label: 'Tool Selection', href: '/technical-resources/tool-selection/' },
      { label: 'Safety', href: '/technical-resources/safety/' },
      { label: 'Where to Buy', href: '/where-to-buy/' },
    ],
  },
  {
    label: 'Company',
    links: [
      { label: 'About', href: '/about/' },
      { label: 'Company History', href: '/company-history/' },
      { label: 'Historic Work', href: '/historic-work/' },
      { label: 'Contact', href: '/contact/' },
      { label: 'Careers', href: '/careers/' },
    ],
  },
]

export const CONTACT = {
  phoneLabel: '800-397-7745',
  phoneHref: 'tel:+18003977745',
  email: 'sales@sheargeometry.com',
  emailHref: 'mailto:sales@sheargeometry.com',
  mailingAddress: '325 Sharon Park Drive, Unit #444, Menlo Park, CA 94025',
}
